import React, { useEffect, useRef, useState } from "react";
import * as Style from "./MedicalInformationStyles";
import MenuIcon from "../../../../../assets/disabilityIcons/Menu.svg";
import helpIcon from "../../../../../assets/IC_Help.png";
import AddIcon from "../../../../../assets/disabilityIcons/Frame 427319007.svg";
import { DisabilityFormCreator } from "../../../../../newComponents/V2Insurance/components/DisabilityFormCreator";
import { MODULE_API } from "../../../../../apis";
import { Table } from "antd";
import NewLoader from "../../../../../components/styled-components/loader/NewLoader";
import axios from "axios";
import swal from "sweetalert";
import deathApi from "../../../../../apis/death.api";
import { useHistory } from "react-router-dom";

export const MedicalInformation = (props) => {
  const inputFileref = useRef(null);
  const [fields, setFields] = useState({});
  const [tabs, setTabs] = useState([]);
  const [fieldsData, setFieldsData] = useState({});
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [activeTabName, setActiveTabName] = useState("INCOME DETAILS");
  const [submitBody, setSubmitBody] = useState({});
  const [dropdown, setDropdown] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const history = useHistory();
  const [moduleName, setModuleName] = useState("Medical Information");
  const [toUpdate, setToUpdate] = useState(false);
  const [loading, setLoading] = useState(false);
  const [contactlist, setContactList] = useState([]);

  const [tableData, setTableData] = useState({
    uploadDocumentMedicalInformationData: [],
  });

  const getAttributes = async (name) => {
    setLoading(true);

    const res = await MODULE_API.fetchAttributes(name);
    if (res) {
      res.attributes &&
        res.attributes.map((attribute) => {
          setLoading(false);
          setFields((prevValue) => {
            return {
              ...prevValue,
              [attribute["groupName"]]: {
                ...(prevValue[attribute["groupName"]] || {}),
                [attribute["id"]]: attribute,
              },
            };
          });
        });
    }
  };
  const getSelectedRow = (id) => {
    setSelectedIndex(id);
  };
  const deleteRecord = async (record) => {
    try {
      setLoading(true);
      await MODULE_API.deleteItem({
        clientModules: [record.id],
      });
      const res = await fetchData(record.module);
      setTableData((prev) => ({
        ...prev,
        [formatModuleKey(record.module)]: res.records || [],
      }));
    } catch (error) {
      console.error("Failed to delete record:", error);
    } finally {
      setLoading(false);
    }
  };
  const extractFileNameFromUrl = (url) => {
    const urlParts = url.split("/");
    return urlParts[urlParts.length - 1]; // Get the last part of the URL, which is the file name
  };
  const uploadDocCols = [
    {
      title: "Link",
      dataIndex: "Document Upload",
      key: "Document Upload",
      render: (fileName, record) => {
        return record["Document Upload"] ? (
          <div style={{ display: "flex", alignItems: "center" }}>
            {" "}
            <a style={{ color: "#7d8fb3" }} href={record["Document Upload"]} target="blank">
              {" "}
              {record["Uploaded File Name"] || extractFileNameFromUrl(record["Document Upload"])}
            </a>
          </div>
        ) : (
          "N/A"
        );
      },
    },
    {
      title: "Action",
      key: "action",
      render: (record, index) => (
        <React.Fragment>
          <div style={{ display: "flex" }} key={index}>
            {" "}
            <div
              onClick={() => {
                getSelectedRow(record.id);
                setDropdown(!dropdown);
              }}
              style={{
                cursor: "pointer",
                marginRight: "1rem",
                padding: "6px 16px",
                width: "5px",
              }}
            >
              <img src={MenuIcon} style={{ rotate: "90deg" }} alt="menuIcon"></img>{" "}
            </div>
            {dropdown && selectedIndex === record.id && (
              <React.Fragment>
                <div className="dropdown" style={{ zIndex: "9999" }}>
                  <ul className="dropdownul">
                    <li
                      className="liHover"
                      onClick={() => {
                        window.open(record["Document Upload"]);
                      }}
                    >
                      View
                    </li>
                    <li
                      className="liHover"
                      // style={{opacity :record.managedBy==="Plaid" ? "0.3" : "1", cursor: record.managedBy==="Plaid" ? "not-allowed" : "pointer", pointerEvents: record.managedBy === "Plaid" ? "none" : "",  }}
                      onClick={() => {
                        deleteRecord(record);
                        setDropdown(false);
                      }}
                    >
                      Delete
                    </li>
                  </ul>
                </div>
              </React.Fragment>
            )}
          </div>
        </React.Fragment>
      ),
    },
  ];
  useEffect(() => {
    getAttributes(props.activeStep.name);
    fetchAllModulesData();
    getContactsModule();
  }, []);
  useEffect(() => {
    if (fieldsData && fieldsData.id) {
      setToUpdate(true);
    }
  }, [fieldsData]);

  useEffect(() => {
    setTabs(Object.keys(fields));
  }, [fields]);

  useEffect(() => {
    let tabs2 = tabs.map((item) => item.toUpperCase());
    let temp = tabs2.indexOf(activeTabName);
    if (temp !== -1) {
      setActiveTabIndex(temp);
    }
  }, [activeTabName]);
  const updateRecord = async () => {
    try {
      setLoading(true);
      await MODULE_API.updateClientModule(submitBody.id, {
        ...submitBody,
      });
      const res = await fetchData(submitBody.module);
      setTableData((prev) => ({
        ...prev,
        [formatModuleKey(submitBody.module)]: res.records || [],
      }));
      setLoading(false);
    } catch (error) {
      console.log("errorrrr", error);
    }
  };
  const moduleNames = ["Medical Information", "Upload Document Medical Information"];
  const fetchData = async (moduleName) => {
    try {
      const res = await MODULE_API.fetchItems({
        moduleName,
        pageNum: 1,
        limit: 10,
        body: {},
      });
      const records = res.records || [];
      return { moduleName, records }; // Return object with moduleName to map later
    } catch (error) {
      console.error(`Error fetching data for ${moduleName}:`, error);
      return { moduleName, records: [] }; // Return empty if failed
    }
  };
  const formatModuleKey = (moduleName) => {
    return (
      moduleName &&
      moduleName
        .replace(/[^a-zA-Z ]/g, "") // Remove special chars
        .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) =>
          index === 0 ? word.toLowerCase() : word.toUpperCase()
        )
        .replace(/\s+/g, "") + "Data"
    );
  };
  const fetchAllModulesData = async () => {
    setLoading(true);
    try {
      const results = await Promise.all(moduleNames.map((name) => fetchData(name)));
      console.log("All module results:", results);
      const medicalInformationModule = results.find((item) => item.moduleName === "Medical Information");
      console.log("medicalInformationModule", medicalInformationModule);

      if (medicalInformationModule) {
        const targetRecord = medicalInformationModule.records.find(
          (record) => record.subType === "Disability"
        );
        console.log("targetRecord", targetRecord);
        setFieldsData(targetRecord);
      } else {
        console.log("Medical History module not found");
      }
      const tableDataObj = results.reduce((acc, { moduleName, records }) => {
        acc[formatModuleKey(moduleName)] = records;
        return acc;
      }, {});

      setTableData(tableDataObj);
    } catch (error) {
      console.error("Error fetching all modules:", error);
    } finally {
      setLoading(false);
    }
  };
  const createAttributes = async () => {
    try {
      setLoading(true);
      await MODULE_API.addAsset(moduleName, {
        clientModules: [submitBody],
      });
      const res = await fetchData(moduleName);
      setTableData((prev) => ({
        ...prev,
        [formatModuleKey(moduleName)]: res.records || [],
      }));
      setLoading(false);
      setToUpdate(true);
    } catch (error) {
      console.log(error);
    } finally {
      setSubmitBody(null);
    }
  };
  const handleImageUpload = async (event) => {
    const fileSize = event.target.files[0].size / (1024 * 1000); // in MB
    console.log("fileSize in mb", fileSize);
    let uploadFile = event.target.files[0];
    if (uploadFile) {
      const formData = new FormData();
      formData.append("file", uploadFile);
      const name = uploadFile.name;
      const lastDot = name.lastIndexOf(".");
      const fileName = name.substring(0, lastDot);
      const ext = name.substring(lastDot + 1);
      setLoading(true);
      const resdata = await MODULE_API.uploadFile({
        fileExt: ext,
        contentType: uploadFile.type,
      });
      const resupload = await axios.put(resdata.uploadUrl, uploadFile, {
        headers: { "Content-type": uploadFile.type },
      });
      const res = resdata.uploadUrl.split("?")[0];
      console.log("image", res);
      setLoading(false);
      let objToSubmit = {
        "Document Upload": res,
        "Uploaded File Name": name,
      };
      handleSubmit(objToSubmit);
    }
    inputFileref.current.value = null;
  };
  const handleSubmit = async (body) => {
    console.log("Submit...", body);
    try {
      setLoading(true);
      const response = await MODULE_API.addAsset(moduleName, {
        clientModules: [body],
      });
      console.log("resposnse Upload", response);
      if (response && response.message) {
        swal("Success!", response.message, "success");
      }
      const res = await fetchData(moduleName);
      setTableData((prev) => ({
        ...prev,
        [formatModuleKey(moduleName)]: (res && res.records) || [],
      }));
      setLoading(false);
    } catch (error) {
      console.log("error in update", error);
      setLoading(false);
    }
  };
  const getContactsModule = async () => {
    try {
      setLoading(true);
      setContactList([]);
      const apiResponse = await deathApi.getClientContacts();

      if (apiResponse && apiResponse.data) {
        const processedContacts = apiResponse.data.map((contact) => {
          // Trim and handle null/undefined values
          const firstName = (contact.firstName && contact.firstName.trim()) || "";
          const lastName = (contact.lastName && contact.lastName.trim()) || "";

          // Create full name only if at least firstName exists
          let fullName = "";
          if (firstName && lastName) {
            fullName = `${firstName} ${lastName}`;
          } else if (firstName) {
            fullName = firstName;
          } else if (lastName) {
            fullName = lastName;
          } else {
            fullName = (contact.name && contact.name.trim()) || ""; // Fallback to name field
          }

          // Return the full contact object with the calculated fullName
          return {
            fullName: fullName.trim(),
            key: contact.id || Math.random().toString(36).substr(2, 9), // Fallback key if no id
          };
        });

        setContactList(processedContacts);
      }
      setLoading(false);
    } catch (error) {
      console.error("Failed to load contacts:", error);
      setLoading(false);
    }
  };
  console.log("submitBody", submitBody);

  return (
    <div>
      <div style={{ marginBottom: "2rem" }}>
        <Style.MainHeading style={{ display: "flex", justifyContent: "space-between" }}>
          <div>
            Medical Information <Style.HelpIcon src={helpIcon} alt="helpicon" />
          </div>
          <div className="handle-submit-button-container">
          <button className="submit-button" onClick={() => history.push("/client/plan", { from: "/protector/disability" })}>
            Add Contact
          </button>
        </div>
        </Style.MainHeading>

        {tabs.length > 0 && (
          <DisabilityFormCreator
            data={fields[tabs[activeTabIndex]]}
            values={fieldsData}
            title={tabs[activeTabIndex]}
            setSubmitBody={setSubmitBody}
            activeTabName={activeTabName}
            contactsList={contactlist}
          />
        )}
      </div>
      <NewLoader isLoading={loading} />
      {!loading && fields && (
        <div className="handle-submit-button-container">
          <button
            className="submit-button"
            onClick={() => {
              if (toUpdate) {
                updateRecord();
              } else {
                createAttributes();
              }
            }}
          >
            {toUpdate ? "Update" : "Submit"}
          </button>
        </div>
      )}

      <div className="upload-document-container">
        <div className="upload-document-header-container">
          <div className="upload-document-header-title-container">
            <h3 className="header-title">Upload Document</h3>
          </div>
          <div className="upload-document-button-container" style={{ cursor: "pointer" }}>
            <label
              htmlFor="UploadDocumentMedicalInformation"
              onClick={() => {
                setModuleName("Upload Document Medical Information");
              }}
              style={{ cursor: "pointer", pointerEvents: loading && "none" }}
            >
              <img src={AddIcon} alt="Add File" width="24px" height="24px" />
            </label>
            <input
              type="file"
              ref={inputFileref}
              id="UploadDocumentMedicalInformation"
              hidden
              onChange={async (event) => {
                await handleImageUpload(event);
              }}
              accept="image/jpeg, .pdf, .xlsx, .doc"
            />
          </div>
        </div>

        <div className="upload-document-table-container">
          <Table columns={uploadDocCols} dataSource={tableData.uploadDocumentMedicalInformationData} />
          <NewLoader isLoading={loading} />
        </div>
      </div>
    </div>
  );
};
